import { z } from 'zod';
import { normalizeIntervalDays } from '../schedule/interval-days.js';
export const objectIdSchema = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid ObjectId');
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
export const timezoneSchema = z.string().refine((tz) => {
    try {
        Intl.DateTimeFormat(undefined, { timeZone: tz });
        return true;
    }
    catch {
        return false;
    }
}, { message: 'Invalid IANA timezone' });
const timeSchema = z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Time must be in HH:mm format');
export const scheduleConfigSchema = z.object({
    time: timeSchema.optional(),
    daysOfWeek: z.array(z.number().int().min(0).max(6)).optional(),
    intervalDays: z.preprocess((value) => normalizeIntervalDays(value), z.number().int().min(1).max(365).optional()),
    intervalValue: z.number().int().min(1).max(365).optional(),
    intervalUnit: z.enum(['minute', 'hour', 'day', 'week', 'month', 'year']).optional(),
    dayOfMonth: z.number().int().min(1).max(31).optional(),
    daysOfMonth: z.array(z.number().int().min(1).max(31)).min(1).max(31).optional(),
    month: z.number().int().min(1).max(12).optional(),
    day: z.number().int().min(1).max(31).optional(),
    maxOccurrences: z.number().int().min(1).max(9999).optional(),
});
//# sourceMappingURL=common.js.map